import { Heading } from '@uhg-harmony/react';
import { SafeHtml } from '@/utils/SafeHtml';
import styles from './Welcome.module.css';

interface WelcomeProps {
  welcomeHeading: string;
  welcomeNote: string;
  welcomePbaHeading: string;
  welcomeHelpContact: string;
}

export function Welcome({
  welcomeHeading,
  welcomeNote,
  welcomePbaHeading,
  welcomeHelpContact,
}: WelcomeProps) {
  const heading     = welcomeHeading;
  const note        = welcomeNote;
  const pbaHeading  = welcomePbaHeading;
  const helpContact = welcomeHelpContact;

  return (
    <section className={styles.welcome} tabIndex={0}>
      {heading && <Heading level="h2" className={styles.heroHeading}>{heading}</Heading>}
      <div className={styles.content}>
        {pbaHeading && <Heading level="h3" className={styles.pbaHeading}>{pbaHeading}</Heading>}
        <SafeHtml html={note} className={styles.description} />
        {helpContact && (
          <SafeHtml html={helpContact} className={styles.helpContact} />
        )}
      </div>
    </section>
  );
}

